import "./locale/i18n"
import VocLayoutBasic from "../packages/layout-basic/index"
import VocPagination from "../packages/pagination/index"
import VocEditor from "../packages/editor/index"
import VocStatus from "../packages/status/index"
import VocSwitch from "../packages/switch/index"
import VocButton from "../packages/button/index"
import VocAudioPlayer from "../packages/audio-player/index"
import VocTextarea from "../packages/textarea/index"
import VocWaves from "../packages/waves/index"
import VocHeaderMenu from "../packages/header-menu/index"
import VocHeaderMenuMobile from "../packages/header-menu-mobile/index"
import VocDatePicker from "../packages/date-picker/index"
import VocConsole from "../packages/console/index"
import VocServicer from "../packages/servicer/index"
import VocHeaderDownload from "../packages/header-download/index"
import VocFlyDot from "../packages/fly-dot/index"
import VoceAudioPlayerNext from "../packages/audio-player-next/index"
import VocHeaderMenuNew from "../packages/header-menu-new/index"
// import VueI18n from "vue-i18n"
import VocAudioPlayerRemix from "../packages/audio-player-remix/index"

import VocHeaderMenuColumn from "../packages/header-menu-column/index"

import VocWatermark from "../packages/watermark/index"

// 全局注册
const install = function (Vue) {
  const components = [
    VocLayoutBasic,
    VocPagination,
    VocEditor,
    VocStatus,
    VocSwitch,
    VocButton,
    VocAudioPlayer,
    VocTextarea,
    VocWaves,
    VocHeaderMenu,
    VocHeaderMenuMobile,
    VocDatePicker,
    VocConsole,
    VocServicer,
    VocHeaderDownload,
    VoceAudioPlayerNext,
    VocHeaderMenuNew,
    VocWatermark,
    VocAudioPlayerRemix,
    VocHeaderMenuColumn
  ]
  components.forEach(component => {
    Vue.component(component.name, component)
    // Vue.use(component)
  })
  // Vue.use(VueI18n)
  Vue.locale("zh-cn", {
    ...Vue.locale("zh-cn"),
    ...require("./locale/zh_cn")
  })
  Vue.locale("en", {
    ...Vue.locale("en"),
    ...require("./locale/en")
  })
  Vue.prototype.$flydot = VocFlyDot
}

// 导出单个组件
export {
  VocLayoutBasic,
  VocPagination,
  VocEditor,
  VocStatus,
  VocSwitch,
  VocButton,
  VocAudioPlayer,
  VocTextarea,
  VocWaves,
  VocHeaderMenu,
  VocHeaderMenuMobile,
  VocDatePicker,
  VocConsole,
  VocServicer,
  VocHeaderDownload,
  VocFlyDot,
  VoceAudioPlayerNext,
  VocHeaderMenuNew,
  VocWatermark,
  VocAudioPlayerRemix,
  VocHeaderMenuColumn
}

// 导出全局 install 函数
export default {
  install
}
